import React from 'react';
import { formatDateTimeCompact } from '../../utils/dateUtils';

const DOT_COLORS = {
  blue: 'bg-blue-500',
  green: 'bg-green-500',
  orange: 'bg-orange-500',
  red: 'bg-red-500',
  gray: 'bg-gray-400',
};

const EventTimeline = ({ title = 'History', events = [] }) => {
  if (!events.length) return null;

  return (
    <div className="bg-gray-50 rounded-xl p-4">
      <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3">
        {title}
      </h4>
      <div className="relative pl-6 space-y-4 border-l border-gray-200">
        {events.map((event) => (
          <div key={event.id || `${event.label}-${event.timestamp}`} className="relative">
            <div className="absolute -left-7 top-1.5">
              <div
                className={`w-2.5 h-2.5 rounded-full ${
                  DOT_COLORS[event.color] || DOT_COLORS.blue
                } ${event.isPending ? 'animate-pulse ring-2 ring-orange-200' : ''}`}
              />
            </div>
            <div className="flex items-start justify-between gap-2 min-w-0">
              <div className="min-w-0">
                <p className="text-sm font-medium text-gray-900">{event.label}</p>
                {event.subtitle && (
                  <p className="text-xs text-gray-500 mt-0.5 break-words">{event.subtitle}</p>
                )}
              </div>
              {event.timestamp && (
                <span className="text-xs text-gray-400 whitespace-nowrap flex-shrink-0">
                  {formatDateTimeCompact(event.timestamp)}
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EventTimeline;
